import React from "react";

const Bash_Quiz = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Quiz</h2>
      <p>1) Which command shows disk usage per directory? (a) df (b) du (c) free</p><p>2) How do you make a script executable? (a) chmod +x (b) chown (c) alias</p><p>Answers: 1) b, 2) a</p>
    </div>
  );
};

export default Bash_Quiz;
